import React, { lazy } from 'react';
import { AnimatedSection } from './AnimatedSection';
type Logo = {
  name: string;
  src: string;
};
type ChipItem = {
  name: string;
};
type Row = {
  label: string;
  kind: 'logos';
  items: Logo[];
  hint?: string;
} | {
  label: string;
  kind: 'chips';
  items: ChipItem[];
  hint?: string;
};
const rows: Row[] = [{
  label: 'Corrieri',
  kind: 'logos',
  hint: 'e altri',
  items: [{
    name: 'BRT',
    src: 'https://cdn.magicpatterns.com/uploads/wf9e99aANHpZbGZkeamYJG/BRT_logo_cropped.png'
  }, {
    name: 'GLS',
    src: 'https://cdn.magicpatterns.com/uploads/8gaG4DHL5XugjboCg7tGMK/GLS_Logo_2021.svg.png'
  }, {
    name: 'SDA — Poste Italiane',
    src: 'https://cdn.magicpatterns.com/uploads/vH81QcttUiVWLv9eac3keR/1620120317-sda-poste-logo.webp'
  }, {
    name: 'FedEx',
    src: 'https://cdn.magicpatterns.com/uploads/8P9RrYvH89MAn1MhzGp7mz/FedEx-Logo.png'
  }, {
    name: 'UPS',
    src: 'https://cdn.magicpatterns.com/uploads/4ZRMgfVEwvovpgs9cHYJmK/logo_corriere_ups_500.png'
  }]
}, {
  label: 'E-commerce & CRM',
  kind: 'logos',
  hint: 'e altri',
  items: [{
    name: 'Shopify',
    src: 'https://cdn.magicpatterns.com/uploads/dZ8LfDEu7TXMrKETiaN4fT/Shopify_logo_2018.svg.png'
  }, {
    name: 'WooCommerce',
    src: 'https://cdn.magicpatterns.com/uploads/kcjYmZ2jEAg2Rpx4YgKvrc/WooCommerce_logo_(2015).svg.png'
  }, {
    name: 'Magento',
    src: 'https://cdn.magicpatterns.com/uploads/27shqj6PYG4EXdG86ouefp/Magento.svg.png'
  }, {
    name: 'Amazon',
    src: 'https://cdn.magicpatterns.com/uploads/5PSo6XZZHLeVY7dUZ2iuRY/Amazon_logo.svg.png'
  }, {
    name: 'PrestaShop',
    src: 'https://cdn.magicpatterns.com/uploads/jVWpnR5sEhHKpsBTK4cgB3/Prestashop-logo-vector.png'
  }, {
    name: 'TeamSystem',
    src: 'https://cdn.magicpatterns.com/uploads/3WvpAYFeHypTMZik9CF96o/TeamSystem_Colore_300Dpi_43239.jpg'
  }, {
    name: 'Odoo',
    src: 'https://cdn.magicpatterns.com/uploads/7t3SMxjqgsjna4wAkD9QzQ/Odoo_logo.svg.png'
  }]
}, {
  label: 'Canali',
  kind: 'logos',
  hint: 'e altri',
  items: [{
    name: 'WhatsApp',
    src: 'https://cdn.magicpatterns.com/uploads/d4makzfD8ZRBN49J1mfckE/whatsapp_logo_icon_186881.webp'
  }, {
    name: 'Smart Call',
    src: 'https://cdn.magicpatterns.com/uploads/mxRMYDbzJtvRUvVAUCZLmz/phone-call-icon-answer-accept-call-icon-with-green-button-contact-us-telephone-sign-yes-button-incoming-call-icon-vector.jpg'
  }, {
    name: 'SMS',
    src: 'https://cdn.magicpatterns.com/uploads/cchZYprVYJDAUFe7vKxE2K/png-clipart-bulk-messaging-sms-gateway-text-messaging-email-email-miscellaneous-blue-thumbnail.png'
  }, {
    name: 'Email',
    src: 'https://cdn.magicpatterns.com/uploads/dgqy3MPBv99axgtTRVuFHv/4202011emailgmaillogomailsocialsocialmedia-115677_115624.webp'
  }, {
    name: 'Telegram',
    src: 'https://cdn.magicpatterns.com/uploads/8wXZK9tu6kaEAwnDNGpF2Y/Telegram_2019_Logo.svg.png'
  }]
}];
export function Integrations() {
  return <section className="section-pad border-t border-default" id="integrazioni" data-id="element-207">
      <div className="wrap" data-id="element-208">
        {/* Header */}
        <AnimatedSection delay={0} data-id="element-209">
          <div className="max-w-[64ch] mb-12 md:mb-16" data-id="element-210">
            <div className="section-tag section-tag--accent mb-6" data-id="element-211">
              INTEGRAZIONI
            </div>
            <h2 className="text-display-section mb-6" data-id="element-212">
              Si integra con il tuo stack.
            </h2>
            <p className="text-body-lg color-ink-secondary" data-id="element-213">
              Aisac si collega ai principali corrieri, alle piattaforme
              e-commerce e CRM, e ai canali di comunicazione che già usi — senza
              cambiare i tuoi processi.
            </p>
          </div>
        </AnimatedSection>

        {/* Rows */}
        <div className="flex flex-col gap-4 md:gap-5" data-id="element-214">
          {rows.map((row, i) => <AnimatedSection key={row.label} delay={0.05 + i * 0.05} data-id="element-215">
              <div className="rounded-lg border border-default bg-[#0a0a0a] p-5 md:p-6" data-id="element-216">
                <div className="flex flex-col md:flex-row md:items-center md:gap-8 gap-5" data-id="element-217">
                  {/* Left: row label */}
                  <div className="md:w-[180px] md:shrink-0" data-id="element-218">
                    <div className="text-mono-tiny color-accent uppercase" style={{
                  letterSpacing: '0.14em'
                }} data-id="element-219">
                      {row.label}
                    </div>
                    {row.hint && <div className="mt-1.5 text-body-sm color-ink-tertiary" data-id="element-220">
                        {row.hint}
                      </div>}
                  </div>

                  {/* Right: items */}
                  <div className="flex-1 min-w-0" data-id="element-221">
                    {row.kind === 'logos' ? <ul className="flex flex-wrap items-center gap-3 md:gap-4" data-id="element-222">
                        {row.items.map(logo => {
                    const isPrestaShop = logo.name === 'PrestaShop';
                    return <li key={logo.name} className="flex items-center justify-center h-12 md:h-14 px-4 md:px-5 rounded-md bg-white border border-default" title={logo.name} data-id="element-223">
                              <img src={logo.src} alt={logo.name} className={isPrestaShop ? 'h-9 md:h-11 w-auto object-contain' : 'h-6 md:h-7 w-auto object-contain'} loading="lazy" data-id="element-224" />
                            </li>;
                  })}
                      </ul> : <ul className="flex flex-wrap gap-2.5" data-id="element-225">
                        {row.items.map(chip => <li key={chip.name} className="px-4 py-2 rounded-full border border-default bg-elev1 text-body-sm color-ink-primary" data-id="element-226">
                            {chip.name}
                          </li>)}
                      </ul>}
                  </div>
                </div>
              </div>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}